<template>
  <v-menu transition="slide-y-transition" offset-y bottom>
    <template #activator="{ on: menu }">
      <div v-on="{ ...menu }">
        <v-btn data-e2e-id="user-dropdown" outlined dark class="activator-button">
          <app-icon class="mr-2">account_circle</app-icon>
          <!-- eslint-disable vue/no-v-html -->
          <span
            v-if="orgActive()"
            style="text-align: left;"
            v-html="fullName + '<br />' + activeOrganization.name"
          />
          <!-- eslint-enable vue/no-v-html -->
          <span v-else>{{ fullName }}</span>
          <app-icon>arrow_drop_down</app-icon>
        </v-btn>
      </div>
    </template>
    <v-list style="width: 300px; max-height: 600px" class="overflow-y-auto">
      <v-list-item>
        <app-icon class="my-0 mr-2" size="45">account_circle</app-icon>
        <v-list-item-content>
          <v-list-item-title>{{ fullName }}</v-list-item-title>
          <v-list-item-subtitle>{{ activeOrganization.name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="hasOtherOrganizations" class="mt-2 mb-2" />
      <v-list-item v-if="hasOtherOrganizations" class="list-subheading">
        <v-list-item-subtitle>Additional Institutions</v-list-item-subtitle>
      </v-list-item>
      <v-list-item
        v-for="org in otherOrganizations"
        :key="org.id"
        :data-e2e-id="orgElementId(org.name)"
        @click.stop
        @click="changeOrganization(org.id)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ org.name }}</v-list-item-title>
          <v-list-item-subtitle v-if="org.type === 'RESEARCH'">Research</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mt-2 mb-2" />
      <v-list-item
        :href="typeof manageAccountLink === 'string' ? manageAccountLink : undefined"
        :to="typeof manageAccountLink === 'string' ? undefined : manageAccountLink"
        @click.stop
      >
        <v-list-item-content>
          <v-list-item-title>Account Settings</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item data-e2e-id="sign-out" :to="signOutRoute" @click.stop>
        <v-list-item-content>
          <v-list-item-title>Sign Out</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  MyActiveOrganization,
  MyOtherOrganizations,
  setMyActiveOrganization
} from '@/helpers/my-account-helper'
import _ from 'lodash'
import { keycloakService } from '@/services/keycloak-service'
import { isFeatureOn } from '@/helpers/feature-flag-helper'

export default {
  data() {
    return {
      activeOrganization: MyActiveOrganization || {},
      fullName: keycloakService.fullName(),
      signOutRoute: { name: 'logout' },
      otherOrganizations: MyOtherOrganizations,
      hasOtherOrganizations: !_.isEmpty(MyOtherOrganizations)
    }
  },
  computed: {
    manageAccountLink() {
      if (isFeatureOn('viper-platform-ui-react-manage-account-page')) {
        return `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/account`
      }
      return { name: 'account' }
    }
  },
  methods: {
    changeOrganization(id) {
      setMyActiveOrganization({}, id)
      window.location.href = '/'
    },
    orgElementId(orgName) {
      return _.kebabCase(`switch to ${orgName}`)
    },
    orgActive() {
      return !_.isEmpty(this.activeOrganization)
    }
  }
}
</script>

<style lang="scss" scoped>
.activator-button {
  padding-right: 5px;
  padding-left: 5px;
  margin-left: 0;
  border: none;
}

.list-subheading {
  height: 40px;
}

#user-dropdown {
  text-transform: none;
}
</style>
